import { render } from "./IconDoubleChevron.vue?vue&type=template&id=5b584d85&scoped=true&ts=true"
import script from "./IconDoubleChevron.vue?vue&type=script&lang=ts"
export * from "./IconDoubleChevron.vue?vue&type=script&lang=ts"

import "./IconDoubleChevron.vue?vue&type=style&index=0&id=5b584d85&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b584d85"]])

export default __exports__